import { createContext } from 'react';
export const ModeContext = createContext<any>('clock');